<template>
  <table class="table table-borderless table-align table-h51">
    <thead>
      <tr>
        <th>ID</th>
        <th>Scraper name</th>
        <th>Código</th>
        <th>Descrição</th>
        <th>Descrição tratada</th>
        <th>Criado por</th>
        <th>Criado em</th>
        <th></th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="ticket in ticketDescriptions" :key="ticket.id">
        <td>{{ ticket.id }}</td>
        <td>{{ ticket.scraperName }}</td>
        <td>{{ ticket.code }}</td>
        <td>{{ ticket.description }}</td>
        <td>{{ ticket.treatedDescription }}</td>
        <td>{{ ticket.createdBy }}</td>
        <td>{{ ticket.createdAt | datetime }}</td>
        <td>
          <button class="btn btn-outline" @click="$emit('deleteEntity', ticket)">
            Excluir
          </button>
        </td>
      </tr>
      </tbody>
  </table>
</template>

<script>

export default {
  name: 'Table',
  props: {
    ticketDescriptions: { required: true, type: Array }
  }
}

</script>

<style scoped>

</style>